module.exports = __webpack_public_path__ + "static/media/IconTemplates_-14.3eac0cd6.svg";